function getAttr(arr, attr) {
  if (!arr) return "";
  const found = arr.find(x => x.attributename === attr);
  if (!found) return "";
  let values = found.value || [];
  let result = "";
  if (Array.isArray(values)) {
    if (values[0]?.lang === "tr" && Array.isArray(values[0].value))
      result = values[0]?.value?.[0] || "";
    else if (typeof values[0] === "object" && values[0]?.value)
      result = Array.isArray(values[0].value) ? values[0].value[0] : values[0].value;
    else
      result = values[0];
  } else {
    result = values;
  }

  if (attr === "Başlık" && typeof result === "string") {
    return result.replace(/\s*\/$/, '').trim();
  }
  return result;
}

function getPages(pub) {
  // Kitap bölümü ve makale için sayfa aralığı
  const first =
    getAttr(pub.publicationtypeInfo, "İlk Sayfa") ||
    getAttr(pub.templateInfo, "İlk Sayfa") ||
    "";
  const last =
    getAttr(pub.publicationtypeInfo, "Son Sayfa") ||
    getAttr(pub.templateInfo, "Son Sayfa") ||
    "";
  if (first && last) return `${first}-${last}`;
  if (first) return first;
  if (last) return last;
  return "";
}

function getISSN(pub) {
  // parentlarda da bak
  return (
    getAttr(pub.publicationtypeInfo, "ISSN") ||
    getAttr(pub.templateInfo, "ISSN") ||
    getAttr(pub.parentList?.[1]?.publicationtypeInfo, "ISSN") ||
    getAttr(pub.parentList?.[0]?.publicationtypeInfo, "ISSN") ||
    ""
  );
}

function getDOI(pub) {
  return (
    getAttr(pub.publicationtypeInfo, "DOI") ||
    getAttr(pub.templateInfo, "DOI") ||
    getAttr(pub.parentList?.[0]?.publicationtypeInfo, "DOI") ||
    getAttr(pub.parentList?.[1]?.publicationtypeInfo, "DOI") ||
    ""
  );
}

function getVolume(pub) {
  return (
    getAttr(pub.parentList?.[0]?.publicationtypeInfo, "Cilt") ||
    getAttr(pub.publicationtypeInfo, "Cilt") ||
    ""
  );
}

function getIssue(pub) {
  return (
    getAttr(pub.parentList?.[0]?.publicationtypeInfo, "Sayı") ||
    getAttr(pub.publicationtypeInfo, "Sayı") ||
    ""
  );
}

function getJournal(pub) {
  // parentList[1] Dergi, parentList[0] Sayı (issue)
  return (
    getAttr(pub.parentList?.[1]?.publicationtypeInfo, "Başlık") ||
    getAttr(pub.parentList?.[1]?.publicationtypeInfo, "Dergi Adı") ||
    getAttr(pub.parentList?.[0]?.publicationtypeInfo, "Başlık") ||
    getAttr(pub.parentList?.[0]?.publicationtypeInfo, "Dergi Adı") ||
    ""
  );
}

function getISBN(pub) {
  return (
    getAttr(pub.publicationtypeInfo, "ISBN") ||
    getAttr(pub.templateInfo, "ISBN") ||
    getAttr(pub.parentList?.[0]?.publicationtypeInfo, "ISBN") ||
    getAttr(pub.parentList?.[1]?.publicationtypeInfo, "ISBN") ||
    ""
  );
}

function getEditor(pub) {
  return (
    getAttr(pub.publicationtypeInfo, "Editör") ||
    getAttr(pub.templateInfo, "Editör") ||
    getAttr(pub.parentList?.[0]?.publicationtypeInfo, "Editör") ||
    ""
  );
}

function getBookTitle(pub) {
  return (
    getAttr(pub.parentList?.[0]?.publicationtypeInfo, "Başlık") ||
    ""
  );
}

function getPublisher(pub) {
  if (pub?.publishers?.[0]?.title) return pub.publishers[0].title;
  return (
    getAttr(pub.publicationtypeInfo, "Yayınevi") ||
    getAttr(pub.publicationtypeInfo, "Yayıncı") ||
    getAttr(pub.parentList?.[0]?.publishers?.[0]?.title) ||
    getAttr(pub.parentList?.[0]?.publicationtypeInfo, "Yayınevi") ||
    getAttr(pub.parentList?.[0]?.publicationtypeInfo, "Yayıncı") ||
    ""
  );
}

function getYear(pub) {
  let year =
    getAttr(pub.publicationtypeInfo, "Yayın Tarihi") ||
    getAttr(pub.publicationtypeInfo, "Yayın Yılı") ||
    getAttr(pub.templateInfo, "Yayın Tarihi") ||
    getAttr(pub.templateInfo, "Yayın Yılı") ||
    getAttr(pub.parentList?.[0]?.publicationtypeInfo, "Yayın Tarihi") ||
    getAttr(pub.parentList?.[0]?.publicationtypeInfo, "Yayın Yılı");
  if (year && typeof year === "string" && year.length >= 4) year = year.slice(0, 4);
  return year || "";
}

export function mapPublicationData(pub) {
  const type = pub.publicationtype || "";

  // Author extraction
  const authorsArr = (pub.authors || []).map(a => {
    const name = (a.name || "").trim();
    const surname = (a.surname || "").trim();

    return {
      ...a,
      name,
      surname,
      // Soyadı boşsa veya sadece nokta/tire gibi karakterlerse "Tek İsim" kabul et
      isSingleName: !surname || surname === "." || surname === "-"
    };
  });

  const authors = authorsArr.map(a =>
    a.isSingleName ? a.name : `${a.name} ${a.surname}`
  ).join(", ");

  // Konferans ise parent'taki Konferans Adı'nı, Kitap ise Başlığı al
  const parentPubInfo = pub.parentList?.[0]?.publicationtypeInfo;

  // Eğer yayın türü konferans ise ve bir üst veri varsa, kitap adı oradaki konferans adı olmalı
  let mappedBookTitle = getBookTitle(pub);
  if (type.includes("Konferans")) {
    mappedBookTitle = getAttr(parentPubInfo, "Konferans Adı") || mappedBookTitle;
  }

  const d = {
    type,
    title: getAttr(pub.publicationtypeInfo, "Başlık"),
    authors,
    authorsArr,
    publisher: getPublisher(pub),
    editor: getEditor(pub),
    year: getYear(pub),
    journal: getJournal(pub),
    volume: getVolume(pub),
    issue: getIssue(pub),
    pages: getPages(pub),
    issn: getISSN(pub),
    isbn: getISBN(pub),
    doi: getDOI(pub),
    bookTitle: mappedBookTitle, // Güncellenmiş mantık
    confName: getAttr(parentPubInfo, "Konferans Adı"),
    city: getAttr(parentPubInfo, "Yayın Yeri"),
  };
  return d;
}
